import React from "react";
var __jsx = React.createElement;
import Radio from "./Radio/Radio";
import stl from "./RadioGroup.module.css";
var RadioGroup = function RadioGroup(_ref) {
  var setAnswer = _ref.setAnswer,
    secondaryAnswer = _ref.secondaryAnswer,
    options = _ref.options,
    mainAnswer = _ref.mainAnswer,
    error = _ref.error,
    setError = _ref.setError;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.radioGroup, " ").concat(error && mainAnswer ? stl.shake : ""),
    onAnimationEnd: function onAnimationEnd(e) {
      return e.target.classList.remove(stl.shake);
    }
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Radio, {
      key: option.id,
      name: "secondary-answer",
      label: option.text,
      value: option.id,
      setAnswer: setAnswer,
      answers: secondaryAnswer,
      setError: setError
    });
  }));
};
export default RadioGroup;